// extracted by mini-css-extract-plugin
export var hidden = "ScrollButton-module--hidden--fece3";
export var icon = "ScrollButton-module--icon--c3120";
export var wrapper = "ScrollButton-module--wrapper--efc7e";